<template>
  <div class="campaign-toggle-row">
    <div class="campaign-toggle-row__info">
      <p class="campaign-toggle-row__name">{{ campaign.name }}</p>
      <p v-if="campaign.orgName" class="campaign-toggle-row__org">{{ campaign.orgName }}</p>
    </div>
    <div class="swich-elem">
      <b-form-checkbox
        :checked="!campaign.unsubscribed"
        :disabled="busy"
        @click.native.prevent="onClick"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      if (this.busy) {
        return;
      }
      // The click is prevented so the switch only moves once the parent
      // confirms the API call succeeded and updates `campaign.unsubscribed`.
      this.$emit("toggle", {
        campaignId: this.campaign.id,
        subscribed: Boolean(this.campaign.unsubscribed),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.campaign-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 12px 0;
  border-bottom: 1px solid #e6eaed;
  &__name {
    margin: 0;
    font-size: 17px;
  }
  &__org {
    margin: 0;
    font-size: 14px;
    color: #7c8a97;
  }
}
.swich-elem {
  .custom-checkbox {
    display: block;
    padding-left: 0;
    font-size: 17px;
    margin-bottom: 0;
    ::v-deep .custom-control-label {
      padding-left: 50px;
      position: relative;
      &:before {
        width: 38px;
        height: 20px;
        left: 0;
        background: #dee4eb;
        border-radius: 10px;
        box-shadow: 0 2px 10px 0 rgba(4, 19, 36, 0.05);
        outline: none !important;
        border: none !important;
      }
      &:after {
        width: 20px;
        height: 20px;
        left: 0px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 4px 12px 0 rgba(3, 12, 41, 0.08);
      }
    }
    ::v-deep .custom-control-input:focus + .custom-control-label {
      &:before {
        outline: none !important;
        border: none !important;
        box-shadow: none !important;
      }
    }
    ::v-deep .custom-control-input:checked + .custom-control-label {
      &:before {
        background: #00d39c;
      }
      &:after {
        width: 20px;
        height: 20px;
        left: 18px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 4px 12px 0 rgba(3, 12, 41, 0.08);
      }
    }
  }
}
</style>
